export default "__VITE_ASSET__D4cAd$Ks__"